<div #mainDiv_ll_model_permissions>


  <div [hidden]="!bundle.showGrid"
       [style.top.px]="bundle.gridY"
       [style.left.px]="bundle.gridX"
       style="position: absolute; z-index: 100">

    <jqxGrid #datagrid_companies_ll_model_permissions
             [width]="bundle.gridW"
             [height]="bundle.gridH"
             [editable]="true"
             [editmode]="'click'"
             [rowsheight]="20"
             [filterable]="true"
             [sortable]="true"
             [showheader]="true"
             [columnsresize]="true"
             [showstatusbar]="false"
             (onCellclick)="clickOnCell_companies($event)">


    </jqxGrid>

    <jqxGrid #datagrid_contacts_ll_model_permissions
             [width]="bundle.gridW"
             [height]="bundle.gridH"
             [editable]="true"
             [editmode]="'click'"
             [rowsheight]="20"
             [filterable]="true"
             [sortable]="true"
             [showheader]="true"
             [columnsresize]="true"
             [showstatusbar]="false"
             (onCellclick)="clickOnCell_contacts($event)">


    </jqxGrid>

    <div style="padding-top: 10px">

      <!--<div *ngIf="bundle.showDownloadBtn" style="float: left;">-->
      <div class="wordBtn_11" (click)="exportOnClick()">Download Above List</div>
      <!--</div>-->
    </div>

  </div>


</div>
